import React, { useEffect, useState } from "react";
import { Type, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, formatApiError, PAGE_TEXT_DEFAULTS } from "@/lib/api";

const GROUPS = [
  ["Login", [["login_title", "Título"], ["login_subtitle", "Subtítulo"], ["login_note", "Observação"]]],
  ["Reservas", [["reservas_tagline", "Frase abaixo da logo"], ["reservas_section_title", "Título da lista de espaços"]]],
  ["DayUse", [["dayuse_kicker", "Texto acima do título"], ["dayuse_title", "Título"], ["dayuse_title_accent", "Título (parte laranja)"], ["dayuse_subtitle", "Subtítulo"], ["dayuse_ranking_title", "Título do ranking"], ["dayuse_ranking_subtitle", "Subtítulo do ranking"], ["dayuse_games_title", "Título dos jogos"], ["dayuse_confirmed_title", "Título dos confirmados"], ["dayuse_inactive_title", "Sem DayUse — título"], ["dayuse_inactive_subtitle", "Sem DayUse — descrição"]]],
  ["Bar", [["bar_title", "Título"], ["bar_subtitle", "Subtítulo"]]],
];

export default function PageTextsManager() {
  const [texts, setTexts] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setTexts(r.data.page_texts || {})).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.post("/admin/settings/page-texts", { texts }); toast.success("Textos salvos!"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="page-texts-manager">
      <div className="flex items-center gap-2">
        <Type className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Títulos, subtítulos e descrições</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Deixe em branco para usar o texto padrão (mostrado em cinza). Os textos dos botões do menu ficam em Logos, Imagens e Banners.</p>
      {GROUPS.map(([title, fields]) => (
        <div key={title} className="mt-4 rounded-2xl border border-slate-200 bg-white p-4">
          <p className="font-display text-base font-bold text-slate-900">{title}</p>
          <div className="mt-2 space-y-2">
            {fields.map(([k, label]) => (
              <label key={k} className="block">
                <span className="text-xs font-semibold text-slate-500">{label}</span>
                <Input data-testid={`pagetext-${k}`} placeholder={PAGE_TEXT_DEFAULTS[k]} value={texts[k] || ""} onChange={(e) => setTexts({ ...texts, [k]: e.target.value })} className="mt-1 rounded-xl" />
              </label>
            ))}
          </div>
        </div>
      ))}
      <Button data-testid="pagetext-save" onClick={save} disabled={saving} className="mt-4 rounded-full bg-[#1B7A45] px-6 text-white hover:bg-[#156337]"><Save className="mr-1.5 h-4 w-4" /> {saving ? "Salvando..." : "Salvar textos"}</Button>
    </div>
  );
}
